import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopuneonlinecab() {



const cardData = {
  keyword: " Mumbai to Pune Online Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Pune online cab services, ensuring a smooth and hassle-free journey with the convenience of digital booking. Travelers can book their cab online from anywhere in Mumbai and enjoy prompt pickups, professional drivers, and well-maintained vehicles. Our online cab services cater to business trips, airport transfers, family outings, and leisure travel, offering transparent pricing, flexible one-way or round-trip options, and no hidden charges. With a fleet of air-conditioned sedans, spacious SUVs, and luxury cars, plus 24/7 customer support, Velocity Cab makes Mumbai to Pune travel convenient, secure, and stress-free.",

topPlaces: [
  
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument linked to India’s freedom movement. It features elegant architecture, spacious gardens, and a museum dedicated to Mahatma Gandhi and important historical events."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a popular heritage site in Pune offering panoramic city views from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy a peaceful, scenic environment."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a well-known garden in Pune featuring lush green spaces and the famous Siddhivinayak Temple. It is a favorite spot for families, walkers, and visitors seeking relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a riverside park offering greenery, walking tracks, and boating facilities. It is a peaceful location for evening strolls and leisure activities in Pune."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts, including sculptures, musical instruments, and cultural items that reflect India’s heritage and traditions."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered spiritual landmarks dedicated to Lord Ganesha. Devotees and travelers can experience divine blessings, beautifully decorated idols, and a vibrant atmosphere, especially during major festivals like Ganesh Chaturthi."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gateways, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a serene Japanese-style garden featuring lush greenery, water streams, and beautifully designed walking paths. It is an ideal place for relaxation, photography, and peaceful nature walks."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a popular shopping and entertainment hub featuring international brands, restaurants, cinemas, and entertainment zones, making it ideal for leisure and shopping experiences."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its spiritual ambiance and historical significance in Pune."
  }
],



services: [
{
name: "Mumbai to Pune Online Cab",
description: "Mumbai to Pune online cab service allows travelers to easily book comfortable taxis between the two cities through online platforms. Passengers can schedule rides instantly from homes, offices, railway stations, or hotels anywhere in Mumbai and travel smoothly to Pune via the Mumbai–Pune Expressway. Multiple vehicle options including sedan, Ertiga, and Innova are available depending on passenger comfort and group size. Professional drivers ensure safe highway driving, punctual pickups, and smooth long-distance journeys. Online booking offers instant confirmation, transparent fares, and flexible pickup timing. This service is ideal for business travelers, tourists, and families looking for reliable intercity transportation. Spacious luggage space and air-conditioned vehicles ensure a comfortable and stress-free ride. Passengers can also choose one-way or round-trip options according to their travel plans. Online cab booking makes intercity travel faster, easier, and more convenient."
},
{
name: "Mumbai Airport to Pune Taxi Online Booking",
description: "Mumbai Airport to Pune taxi online booking service helps passengers arriving at Chhatrapati Shivaji Maharaj International Airport easily reserve taxis to Pune city. Travelers can pre-book rides online before landing so that a professional driver is ready for pickup at the airport terminal. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel with sufficient luggage space. Drivers monitor flight schedules and adjust pickup timing in case of flight delays. This airport transfer service is ideal for corporate travelers, families, and tourists traveling directly from the airport to Pune. Online booking provides clear pricing, instant confirmation, and convenient ride scheduling. Air-conditioned vehicles ensure relaxed travel even after long flights. Safe driving and well-maintained vehicles make the journey comfortable and reliable."
},
{
name: "Mumbai to Pune Online Innova Taxi",
description: "Mumbai to Pune online Innova taxi service offers premium SUV travel for passengers who prefer spacious and comfortable vehicles. Toyota Innova and Innova Crysta vehicles provide excellent seating capacity, smooth highway performance, and extra luggage space for long-distance travel. Online booking allows travelers to instantly reserve rides from any location in Mumbai including residential areas, hotels, railway stations, and airport terminals. Professional drivers ensure safe driving through the Mumbai–Pune Expressway and provide punctual pickup services. This service is ideal for families, business travelers, and groups traveling together. Comfortable interiors and air-conditioning make the journey relaxing throughout the trip. Transparent pricing and flexible scheduling make Innova taxis a popular option for intercity travel. Passengers can choose one-way or round-trip travel depending on their itinerary."
},
{
name: "Mumbai to Pune Online Ertiga Taxi",
description: "Mumbai to Pune online Ertiga taxi service provides comfortable 7-seater SUV transportation for passengers traveling between the two cities. The Maruti Ertiga is ideal for families and small groups who want spacious seating with economical pricing. Travelers can easily book Ertiga taxis online and receive instant booking confirmation. Professional drivers provide safe driving and timely pickup services from homes, offices, and hotels across Mumbai. Smooth highway travel via the Mumbai–Pune Expressway ensures a convenient journey. Air-conditioned vehicles and comfortable seating make long-distance travel pleasant. This service is frequently used for airport transfers, corporate trips, and family travel. Flexible travel timing and transparent pricing make the booking process simple."
},
{
name: "Mumbai to Pune Online Round Trip Taxi",
description: "Mumbai to Pune online round trip taxi service provides convenient travel for passengers who need transportation for both onward and return journeys. Travelers can book taxis online and keep the same vehicle for the entire trip duration. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel. Professional drivers remain available for local travel in Pune as well as the return trip to Mumbai. This service is ideal for business meetings, weekend travel, sightseeing, and family visits. Passengers benefit from flexible scheduling and better fare value compared to separate bookings. Spacious vehicles provide comfortable seating and luggage capacity. Online booking allows travelers to easily plan complete intercity travel."
},
{
name: "Online Cab Booking Mumbai to Pune",
description: "Online cab booking Mumbai to Pune service allows travelers to reserve taxis quickly through websites or mobile platforms. Passengers can choose vehicle types, select pickup time, and confirm bookings instantly. Comfortable vehicles ensure smooth highway travel while professional drivers provide punctual pickup services. This service is ideal for both business and leisure travelers traveling between the two cities. Online booking eliminates the need to search for taxis at the last minute. Transparent fare information and secure booking systems make the process convenient and reliable."
},
{
name: "Mumbai to Pune 24x7 Cab Booking",
description: "Mumbai to Pune 24x7 cab booking service offers round-the-clock taxi availability for passengers traveling anytime during the day or night. Travelers can schedule rides at their preferred time including early morning airport transfers or late night departures. Comfortable vehicles such as sedan, Ertiga, and Innova ensure safe and reliable travel through the expressway. Professional drivers provide timely pickups and maintain high safety standards. This service is perfect for emergency travel, airport transfers, corporate trips, and family journeys. Flexible scheduling ensures passengers always have reliable transportation."
},
{
name: "Online Cab Booking Pune to Mumbai",
description: "Online cab booking Pune to Mumbai service provides convenient return transportation for travelers heading back to Mumbai. Passengers can easily reserve taxis through online platforms and enjoy comfortable travel through the Mumbai–Pune Expressway. Pickup locations are available across Pune including Hinjewadi, Baner, Wakad, Kharadi, and Viman Nagar. Professional drivers ensure safe highway driving and punctual service. Comfortable vehicles with air-conditioning and luggage space make the journey relaxing. Online booking ensures instant confirmations and clear pricing."
},
{
name: "Mumbai Online Cab Booking",
description: "Mumbai online cab booking service allows passengers to reserve taxis instantly for city rides, airport transfers, and outstation journeys. Travelers can choose from different vehicle options including sedan, Ertiga, and Innova depending on travel needs. Professional drivers ensure safe and reliable transportation across Mumbai. Online booking platforms provide transparent fare details and quick confirmation. This service is convenient for both short city trips and long-distance travel."
},
{
name: "Online Taxi Booking Mumbai",
description: "Online taxi booking Mumbai service offers convenient ride booking through digital platforms for city travel and outstation journeys. Travelers can schedule rides in advance and enjoy comfortable transportation with experienced drivers. Vehicles are well maintained and equipped with air-conditioning to ensure passenger comfort. Instant booking confirmation and transparent fare details make the process easy and reliable."
},
{
name: "Mumbai Airport Taxi Booking Online",
description: "Mumbai airport taxi booking online allows passengers to reserve taxis before arriving at the airport. Travelers can schedule pickups from airport terminals and travel comfortably to destinations such as Pune, Navi Mumbai, or nearby cities. Professional drivers ensure timely pickup and safe travel throughout the journey. Spacious vehicles allow convenient luggage handling for travelers."
},
{
name: "Taxi Booking in Mumbai",
description: "Taxi booking in Mumbai provides easy transportation for passengers traveling within the city or to nearby destinations. Travelers can book taxis for airport transfers, business trips, sightseeing tours, and outstation travel. Comfortable vehicles and experienced drivers ensure safe journeys. Reliable service and flexible booking options make taxi travel convenient."
},
{
name: "Online Cab Service in Mumbai",
description: "Online cab service in Mumbai offers quick and convenient ride booking for passengers traveling within the city or outside Mumbai. Travelers can reserve taxis online and enjoy comfortable rides with professional drivers. This service supports city travel, airport transfers, and intercity trips."
},
{
name: "Online Cab in Mumbai",
description: "Online cab in Mumbai service provides convenient taxi booking through websites and mobile platforms. Passengers can instantly schedule rides and travel comfortably with professional drivers and well-maintained vehicles."
},
{
name: "Online Taxi Booking from Mumbai Airport",
description: "Online taxi booking from Mumbai Airport provides easy access to taxis for passengers arriving at airport terminals. Travelers can pre-book rides and travel directly to Pune, Navi Mumbai, or other nearby destinations. Professional drivers ensure smooth airport pickup services."
},
{
name: "Online Taxi Service in Mumbai",
description: "Online taxi service in Mumbai offers reliable transportation with easy digital booking. Passengers can schedule rides instantly for city travel, airport transfers, and outstation journeys. Comfortable vehicles and experienced drivers ensure smooth travel."
},
{
name: "Mumbai Online Cab Services",
description: "Mumbai online cab services provide modern digital transportation solutions for passengers across the city. Travelers can quickly reserve taxis for city rides, airport transfers, or long-distance travel. Instant booking confirmation and flexible vehicle options ensure convenient travel."
},
{
name: "Outstation Taxi Service in Mumbai",
description: "Outstation taxi service in Mumbai provides long-distance transportation to destinations like Pune, Nashik, Shirdi, Lonavala, and other cities. Comfortable vehicles ensure smooth highway journeys while professional drivers maintain safe driving standards. This service is ideal for family trips, corporate travel, and tourist visits."
},
{
name: "Mumbai Airport to Pune Station Cab Service Rates",
description: "Mumbai Airport to Pune Station cab service rates provide clear fare information for passengers traveling from the airport to Pune Railway Station. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth travel via the expressway. Professional drivers provide timely pickups from airport terminals and safe highway driving. Transparent pricing helps passengers plan airport transfers conveniently."
},
{
name: "Mumbai to Pune Cab Booking Online",
description: "Mumbai to Pune cab booking online service allows travelers to reserve taxis quickly through online platforms without any hassle. Passengers can select vehicle types, schedule pickup times, and confirm bookings instantly. Comfortable vehicles and experienced drivers ensure safe highway travel through the Mumbai–Pune Expressway. This service is ideal for business travel, airport transfers, family visits, and tourist trips. Online booking ensures transparent fares and easy ride management."
}
],

tableData: [
["Mumbai to Pune Online Cab","Mumbai Airport to Pune Taxi Online Booking"],
["Mumbai to Pune Online Innova Taxi","Mumbai to Pune Online Ertiga Taxi"],
["Mumbai to Pune Online Round Trip Taxi","Online Cab Booking Mumbai to Pune"],
["Mumbai to Pune 24x7 Cab Booking","Online Cab Booking Pune to Mumbai"],
["Mumbai Online Cab Booking","Online Taxi Booking Mumbai"],
["Mumbai Airport Taxi Booking Online","Taxi Booking in Mumbai"],
["Online Cab Service in Mumbai","Online Cab in Mumbai"],
["Online Taxi Booking from Mumbai Airport","Online Taxi Service in Mumbai"],
["Mumbai Online Cab Services","Outstation Taxi Service in Mumbai"],
["Mumbai Airport to Pune Station Cab Service Rates","Mumbai to Pune Cab Booking Online"]
],




whychoose: [
  {
    WhyChooseheading: "Easy Online Cab Booking",
    WhyChoosedescription: "Velocity Cabs offers a simple and fast online booking system for Mumbai to Pune cab services. Customers can quickly reserve their ride through phone or online booking with instant confirmation."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently travel between Mumbai and Pune via the Mumbai Pune Expressway. Their familiarity with highway routes and traffic conditions ensures safe and timely travel."
  },
  {
    WhyChooseheading: "Transparent Online Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent and affordable pricing for Mumbai to Pune online cab bookings. Customers receive clear details about travel fares, toll charges, and driver allowances before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Online Cab Availability",
    WhyChoosedescription: "Our Mumbai to Pune online cab service operates 24 hours a day. Whether you need an early morning pickup, business travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and relaxing travel experience between Mumbai and Pune."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Booking",
    WhyChoosedescription: "Velocity Cabs offers flexible booking options including one-way cab service, round-trip travel, airport transfers, and customized intercity travel plans from Mumbai to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Trusted Online Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Pune online cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Pune online cab booking?", answer: "Yes, Velocity Cabs provides easy online cab booking services for travel from Mumbai to Pune." },
  { question: "How far is Mumbai from Pune?", answer: "The road distance between Mumbai and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Mumbai to Pune online cab service available 24 hours?", answer: "Yes, our online cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Mumbai to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab online?", answer: "Yes, customers can book one-way as well as round-trip cab services online between Mumbai and Pune." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, our drivers provide pickup from Mumbai Airport, homes, hotels, offices, and railway stations across Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab in advance?", answer: "Yes, customers can book their Mumbai to Pune online cab in advance for guaranteed availability." },
  { question: "Do you provide drop service anywhere in Pune?", answer: "Yes, Velocity Cabs provides drop services across Pune including Baner, Hinjewadi, Wakad, Kharadi, Hadapsar, and Pimpri Chinchwad." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback:
      "Highway travel from Mumbai to Pune felt very comfortable and well-managed. The cab was punctual, clean, and the ride stayed smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "A hassle-free Mumbai to Pune journey with a very professional service. The vehicle was comfortable, and the drive remained safe and steady the entire way.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Online Cab Booking | Velocity Cabs",
  "description": "Velocity Cabs provides reliable online cab booking from Mumbai to Pune with professional drivers and affordable fares. Book one way or round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for airport transfers, city-to-city travel, and corporate trips. Enjoy safe, comfortable, and punctual rides with 24x7 online booking from Mumbai to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Mumbai to Pune Online Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune online cab with Velocity Cabs. Affordable one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan with 24x7 online booking from Mumbai." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopuneonlinecab;